module.exports = __webpack_public_path__ + "img/sort-icon.e548814f.svg";